import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'
import globalConsts from '../../globalConsts'
import { INDIVIDUAL_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'

import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import { ExternalLink } from 'src/components/Core/Styles/Link'
import Font from 'src/components/Core/Typography/Font/Font'
import Label from 'src/components/Atoms/Label/Label'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'
import { ConfigCompanyDetails } from '../../CorporateAccount/CompanyDetails/types'

export const clientDocumentationLink = <ExternalLink href='https://www.sucdenfinancial.com/en/en/client-documentation-and-disclosures/' />

const SubmitUtilityBillExampleText = (
  <Label
    key='SubmitUtilityBillExampleText'
    removeEllipsis
    // @ts-ignore:next-line
    label={<Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.submitUtilityBillExampleText.label'} components={{requiredMark: <RequiredMark />}}/>}
    tooltipLabel={t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.submitUtilityBillExampleText.tooltipLabel')}
  />
)

const UtilityBillExampleText = (
  <Font
    key='UtilityBillExampleText'
    ellipsis={false}
    lineHeight='24px'
  >
    <Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.utilityBillExampleText.label'} />
  </Font>
)

const CertifiedCopyText = (
  <Font key='certifiedCopyText' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.certifiedCopyText'} components={{requiredMark: <RequiredMark />}} />
  </Font>
)

const DetailsPersonCertifying = (
  <Font key='detailsPersonCertifying' ellipsis={false}>
    {<Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.detailsPersonCertifying'} />}
  </Font>
)

export const NonUSpersonsText = (
  <Font
    key='NonUSpersonsText'
    ellipsis={false}
    margin='0 0 24px 4%'
  >
    <Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.nonUSpersons'} components={{ clientDocumentationLink }} />
  </Font>
)

const config = ({ countries }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'AccountOpeningDocumentationForm',
  path: 'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_PASSPORT,
          },
          // @ts-ignore
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 0 0',
            groupLabel:
              // @ts-ignore
              <Label
                key='passport'
                removeEllipsis
                label={<Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.passport.groupLabel'} components={{requiredMark: <RequiredMark />}}/>}
                tooltipLabel={t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.visualOnly.submitUtilityBillExampleText.tooltipLabel')}
              />,
            inputLabel: t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.passport.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: INDIVIDUAL_SEND_FILE_URL
              }
            },
            step: '1',
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_PASSPORT,
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_DRIVESLICENSE,
          },
          custom: props => InputFilesGroup({
            inputMargin: '0 0 0 0',
            removeBorder: 'top',
            inputLabel: t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.driversLicense.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: INDIVIDUAL_SEND_FILE_URL
              }
            },
            step: '1',
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_DRIVESLICENSE,
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_NATIONALIDENTITYCARD,
          },
          custom: props => InputFilesGroup({
            inputMargin: '0 0 24px 0',
            removeBorder: 'top',
            inputLabel: t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.nationalIdentityCard.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: INDIVIDUAL_SEND_FILE_URL
              }
            },
            step: '1',
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_NATIONALIDENTITYCARD,
            ...props
          }),
        },
        {
          componentType: '',
          visualComponent: SubmitUtilityBillExampleText
        },
        {
          componentType: '',
          visualComponent: UtilityBillExampleText
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_UTILITYBILL,
            required: true
          },
          custom: props => InputFilesGroup({
            inputMargin: '16px 0 32px 0',
            inputLabel: t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.utilityBill.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: INDIVIDUAL_SEND_FILE_URL
              }
            },
            step: '1',
            name: globalConsts.INPUT_FILES_INDIVIDUAL_ACC_OPENING_UTILITYBILL,
            required: true,
            ...props
          }),
        },
        {
          componentType: 'grid',
          // @ts-ignore:next-line
          path: 'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.inputs',
          content: [
            {
              componentType: 'grid',
              props: {
                rowGap: '20px',
                padding: '20px 20px 0 20px',
                boxSizing: 'border-box',
                borderRadius: '3px 3px 0 0',
                backgroundColor: 'neutral-1'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: CertifiedCopyText
                },
                {
                  componentType: '',
                  visualComponent: DetailsPersonCertifying
                }
              ]
            },
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '1fr 1fr 1fr',
                padding: '0 20px 0 20px',
                boxSizing: 'border-box',
                borderRadius: '0 0 3px 3px',
                backgroundColor: 'neutral-1'
              },
              content: [
                {
                  componentType: 'input',
                  props: {
                    name: 'name',
                    required: true,
                    maxlength: 150,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'occupation',
                    required: true,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'addressStreet',
                    required: true,
                    isTextarea: true,
                    textAreaHeight: '48px',
                    textAreaPointerEvents: 'auto',
                    resize: 'none',
                    maxlength: 150,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'addressTownCity',
                    required: true,
                    maxlength: 150,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'addressPostcode',
                    required: true,
                    maxlength: 150,
                  }
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'addressCountry',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'addressCountry',
                    label: 'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.inputs.addressCountry.label',
                    placeholder: 'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.inputs.addressCountry.placeholder',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
              ]
            }
          ]
        },
      ],
    },

  ],
})

export default config
